// useIssueCertificate — DRY: the "issue certificate" action shared by the
// dashboard's Certificates-ready card and the CertificatesPage's
// "Ready to issue" table. Calls POST /api/certificates directly (no
// attendance/payment eligibility check — both callers only ever show
// already-completed, uncertified enrollments).
import { useState } from "react";
import { postJson } from "./useApi.js";
import type { IssueCertificateResult } from "../lib/adminCertificateTypes.js";

export function useIssueCertificate(
  studentId: string,
  courseId: string,
  onIssued: (certificate: IssueCertificateResult) => void
) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function issue() {
    setError(null);
    setIsSubmitting(true);
    const res = await postJson<IssueCertificateResult>("/api/certificates", { studentId, courseId });
    setIsSubmitting(false);
    if (!res.ok) {
      setError(res.error);
      return;
    }
    onIssued(res.data);
  }

  return { isSubmitting, error, issue };
}
